import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-paia-request.component.scss';
import * as $ from 'jquery';
var FormItemPaiaRequest = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemPaiaRequest, _super);
    function FormItemPaiaRequest(element) {
        var _this = _super.call(this, element) || this;
        _this.responseTypes = [{
                value: 'personal',
                text: 'In my personal capacity'
            }, {
                value: 'legal',
                text: 'Legal representative of the requester employee'
            }, {
                value: 'employee',
                text: 'Employee of the requester'
            }, {
                value: 'officer',
                text: 'Information Officer of the requester'
            }, {
                value: 'nextofkin',
                text: 'Next of kin for a deceased individual'
            }, {
                value: 'executor',
                text: 'Executor of a deceased estate'
            }, {
                value: 'business',
                text: 'Representative of a Juristic Entity'
            }, {
                value: 'other',
                text: 'Other (Auditor, Financial Advisor, Family member of a living requester)'
            }];
        return _this;
    }
    FormItemPaiaRequest.prototype.init = function () {
        this.formLoader = this.element.querySelector('.form__loader--container');
        this.formFields = this.element.querySelector('.form__fields--container');
        this.formThankyou = this.element.querySelector('.form__thankyou--container');
        this.customHeading = this.element.querySelector('.customHeading');
        this.form = this.element.querySelector('form');
        this.steps = Array.from(this.element.querySelectorAll('.paia-request__steps--step[data-step]'));
        this.buttonSubmit = this.element.querySelector('.js_paia-step-submit-button');
        this.stepButtons = Array.from(this.element.querySelectorAll('.js_paia-step-button'));
        this.prevButtons = Array.from(this.element.querySelectorAll('.js_paia-step-prev-button'));
        this.hidLeadId = this.form.querySelector('input[name=leadId]');
        this.hidProduct = this.form.querySelector('input[name=product]');
        this.responseTypeSelect = this.form.querySelector('select[name=selectedResponse]');
        this.responseTypeInput = this.form.querySelector('input[name=requesterRole]');
        this.wizardCount = this.element.querySelector('.paia-request__counter--count');
        this.bulletContainer = this.element.querySelector('.paia-request__bullets');
        this.totalSteps = this.element.querySelector('input[name="total-steps"]');
        this.totalSteps.nodeValue = this.steps.length.toString();
        this.showStep(1);
        this.requesteeInfo = Array.from(this.element.querySelectorAll('.requestee-info'));
        if (this.requesteeInfo) {
            this.requesteeInformation('hide');
        }
        this.requesterSACitizen = Array.from(this.element.querySelectorAll('input[name=requesterIsSouthAfrican]'));
        this.requesterId = this.element.querySelector('input[name=requesterIdentificationNumber]');
        this.requesterQuestion = this.element.querySelector('input[name=requesterIsSouthAfrican]');
        this.requesteeSACitizen = Array.from(this.element.querySelectorAll('input[name=requesteeIsSouthAfrican]'));
        this.requesteeId = this.element.querySelector('input[name=requesteeIdentificationNumber]');
        this.thirdPartyCheck = Array.from(this.element.querySelectorAll('input[name=isThirdParty]'));
    };
    FormItemPaiaRequest.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener('click', function (event) {
                var _button = event.target;
                var _form = _button.closest('form');
                var formFields = _form.querySelectorAll('input:not([data-name]), select, textarea');
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll('.form__group--error'));
                // tslint:disable-next-line: triple-equals
                if (valid.length == 0) {
                    _this.submitForm(_form);
                }
            });
        }
        if (this.stepButtons.length) {
            this.stepButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var _event = event.currentTarget;
                var _currentStep = _event.closest('.paia-request__steps--step');
                if (!_currentStep.classList.contains('paia-request__steps--hidden')) {
                    var formFields = _currentStep.querySelectorAll('input, select, textarea');
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_currentStep.querySelectorAll('.form__group--error'));
                    // tslint:disable-next-line: triple-equals
                    if (valid.length == 0) {
                        _this.showNextStep(event);
                    }
                }
            }); });
        }
        if (this.prevButtons.length) {
            this.prevButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var _event = event.currentTarget;
                var _currentStep = _event.closest('.paia-request__steps--step');
                if (!_currentStep.classList.contains('paia-request__steps--hidden')) {
                    _this.showPrevStep(event);
                }
            }); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.responseTypeSelect) {
            this.responseTypeSelect.addEventListener('change', function (pEvent) {
                var _tmpOption = pEvent.target.value;
                var _tmpValue = _this.responseTypes.find(function (pType) {
                    // tslint:disable-next-line: triple-equals
                    if (pType.value == _tmpOption) {
                        return pType;
                    }
                });
                // tslint:disable-next-line: triple-equals
                if (_tmpOption == 'personal') {
                    _this.requesteeInformation('hide', 'personal');
                }
                else {
                    _this.requesteeInformation('show', 'personal');
                }
                // tslint:disable-next-line: triple-equals
                if (_tmpOption == 'business') {
                    _this.showIdNumber('hide', _this.requesterQuestion);
                }
                else {
                    _this.showIdNumber('show', _this.requesterQuestion);
                }
                if (_tmpValue) {
                    _this.responseTypeInput.value = _tmpValue.text;
                }
            });
        }
        if (this.thirdPartyCheck) {
            this.thirdPartyCheck.map(function (item) { return item.addEventListener('click', function (event) {
                var evt = event.target;
                var checkAnswer = evt.value;
                if (checkAnswer === 'Yes') {
                    _this.requesteeInformation('show');
                }
                else {
                    _this.requesteeInformation('hide');
                }
            }); });
        }
        if (this.requesterSACitizen) {
            this.requesterSACitizen.map(function (item) { return item.addEventListener('click', function (event) {
                var evt = event.target;
                var checkAnswer = evt.value;
                if (checkAnswer === 'Yes') {
                    _this.showIdNumber('show', _this.requesterId);
                }
                else {
                    _this.showIdNumber('hide', _this.requesterId);
                }
            }); });
        }
        if (this.requesteeSACitizen) {
            this.requesteeSACitizen.map(function (item) { return item.addEventListener('click', function (event) {
                var evt = event.target;
                var checkAnswer = evt.value;
                if (checkAnswer === 'Yes') {
                    _this.showIdNumber('show', _this.requesteeId);
                }
                else {
                    _this.showIdNumber('hide', _this.requesteeId);
                }
            }); });
        }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            var thirdParty = _this.element.querySelector('.form__success--container-thirdParty');
            if (thirdParty) {
                thirdParty.classList.remove('active');
            }
            var success = _this.element.querySelector('.form__success--container');
            if (success) {
                success.classList.remove('active');
            }
            _this.showIdNumber('hide', _this.requesteeId);
            _this.showIdNumber('hide', _this.requesterId);
            _this.requesteeInformation('hide');
            _this.showStep(1);
            var valid = Array.from(_this.form.querySelectorAll('.form__group--error'));
            valid.map(function (pElem) {
                pElem.classList.remove('form__group--error');
                var errorMessage = pElem.querySelector('.form__group--error_message');
                if (errorMessage) {
                    errorMessage.remove();
                }
            });
        }, false);
        $(document).ready(function () {
            if ($('.paia-multi-select-separated').length) {
                $('.paia-multi-select-separated').multipleSelect({ placeholder: 'Please select', selectAll: false });
            }
        });
    };
    FormItemPaiaRequest.prototype.requesteeInformation = function (state, personal) {
        if (this.requesteeInfo) {
            // tslint:disable-next-line: triple-equals
            if (state == 'show') {
                this.requesteeInfo.map(function (pElem) {
                    if (!pElem.classList.contains('paia-request_requesteeId')) {
                        pElem.classList.remove('form__group--hidden');
                    }
                });
            }
            else {
                this.requesteeInfo.map(function (pElem) {
                    if (!personal) {
                        pElem.classList.add('form__group--hidden');
                    }
                    else if (personal) {
                        if (!pElem.classList.contains('paia-request__responseType')) {
                            pElem.classList.add('form__group--hidden');
                        }
                    }
                });
            }
        }
    };
    FormItemPaiaRequest.prototype.showIdNumber = function (state, pElement) {
        if (this.requesteeInfo) {
            // tslint:disable-next-line: triple-equals
            if (state == 'show') {
                var _parent = pElement.closest('.form__group');
                _parent.classList.remove('form__group--hidden');
            }
            else {
                var _parent = pElement.closest('.form__group');
                _parent.classList.add('form__group--hidden');
            }
        }
    };
    FormItemPaiaRequest.prototype.showStep = function (stepId) {
        var _this = this;
        var _currentstep = this.element.querySelector('[data-step=\'' + stepId + '\']');
        var _heading = _currentstep.getAttribute('data-heading');
        if (_heading) {
            var _h3Heading = this.customHeading.querySelector('h3');
            _h3Heading.innerHTML = _heading;
        }
        var _listItems = document.createElement('ul');
        _listItems.classList.add('paia-request__bullets-container');
        if (this.steps) {
            this.steps.forEach(function (element, index) {
                var _step = element.getAttribute('data-step');
                var _label = element.getAttribute('data-label');
                var _listItem = document.createElement('li');
                // tslint:disable-next-line: triple-equals
                if ((parseFloat(_step) == stepId)) {
                    element.classList.remove('paia-request__steps--hidden');
                    _listItem.classList.add('paia-request__bullets-container--bullet');
                    _listItem.classList.add('paia-request__bullets-container--bullet--active');
                }
                else {
                    element.classList.add('paia-request__steps--hidden');
                    _listItem.classList.add('paia-request__bullets-container--bullet');
                }
                _listItem.innerHTML = '&bull;';
                var _listLabel = document.createElement('div');
                _listLabel.classList.add('paia-request__bullets-container--bullet-label');
                _listLabel.innerHTML = _label;
                _listItem.appendChild(_listLabel);
                _listItems.appendChild(_listItem);
                if (index < (_this.steps.length - 1)) {
                    var _listPipe = document.createElement('li');
                    _listPipe.classList.add('paia-request__bullets-container--bullet');
                    _listPipe.classList.add('paia-request__bullets-container--bullet--link');
                    _listPipe.innerHTML = '&nbsp;';
                    _listItems.appendChild(_listPipe);
                }
            });
        }
        if (this.wizardCount) {
            this.wizardCount.innerHTML = stepId + '/' + parseFloat(this.totalSteps.getAttribute('value'));
        }
        if (this.bulletContainer) {
            this.bulletContainer.innerHTML = '';
            this.bulletContainer.appendChild(_listItems);
        }
        // tslint:disable-next-line: comment-format
        //this.updateForm(this.applicationType.value);
    };
    FormItemPaiaRequest.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest('[data-step]');
        var _nextStep = _currentStep.getAttribute('data-step');
        this.showStep(parseFloat(_nextStep) + 1);
    };
    FormItemPaiaRequest.prototype.showPrevStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest('[data-step]');
        var _nextStep = _currentStep.getAttribute('data-step');
        if (parseFloat(_nextStep) > 0) {
            this.showStep(parseFloat(_nextStep));
        }
        else {
            this.showStep(1);
        }
    };
    FormItemPaiaRequest.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var success = form.querySelector('.form__success--container');
        var successThirdParty = form.querySelector('.form__success--container-thirdParty');
        var error = form.querySelector('.form__error--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var referenceNumber = form.querySelector('.form__success-container__reference');
        var postData = '';
        var isThirdParty = this.form.querySelector('input[name=isThirdParty]');
        var isThirdPartyChecked = this.form.querySelector('input[name=isThirdParty]:checked');
        if (isThirdParty) {
            postData += 'isThirdParty=' + isThirdPartyChecked.value;
        }
        var requesterRole = form.querySelector('input[name=requesterRole]');
        if (requesterRole) {
            postData += '&requesterRole=' + requesterRole.value;
        }
        var selectedResponse = form.querySelector('select[name=selectedResponse]');
        if (selectedResponse) {
            postData += '&selectedResponse=' + selectedResponse.value;
        }
        var requesteeFirstName = this.form.querySelector('input[name=requesteeFirstName]');
        if (requesteeFirstName) {
            postData += '&requesteeFirstName=' + requesteeFirstName.value;
        }
        var requesteeLastName = this.form.querySelector('input[name=requesteeLastName]');
        if (requesteeLastName) {
            postData += '&requesteeLastName=' + requesteeLastName.value;
        }
        var requesteeIsSouthAfrican = this.form.querySelector('input[name=requesteeIsSouthAfrican]');
        if (requesteeIsSouthAfrican) {
            var requesteeIsSouthAfricanChecked = this.form.querySelector('input[name=requesteeIsSouthAfrican]:checked');
            postData += '&requesteeIsSouthAfrican=' + requesteeIsSouthAfricanChecked.value;
        }
        var requesteeContactNumber = this.form.querySelector('input[name=requesteeContactNumber]');
        if (requesteeContactNumber) {
            postData += '&requesteeContactNumber=' + requesteeContactNumber.value;
        }
        var requesteeIdentificationNumber = this.form.querySelector('input[name=requesteeIdentificationNumber]');
        if (requesteeIdentificationNumber) {
            postData += '&requesteeIdentificationNumber=' + requesteeIdentificationNumber.value;
        }
        var requesteeEmailAddress = this.form.querySelector('input[name=requesteeEmailAddress]');
        if (requesteeEmailAddress) {
            postData += '&requesteeEmailAddress=' + requesteeEmailAddress.value;
        }
        var requesterFirstName = this.form.querySelector('input[name=requesterFirstName]');
        if (requesterFirstName) {
            postData += '&requesterFirstName=' + requesterFirstName.value;
        }
        var requesterLastName = this.form.querySelector('input[name=requesterLastName]');
        if (requesterLastName) {
            postData += '&requesterLastName=' + requesterLastName.value;
        }
        var requesterIsSouthAfrican = this.form.querySelector('input[name=requesterIsSouthAfrican]');
        if (requesterIsSouthAfrican) {
            var requesterIsSouthAfricanChecked = this.form.querySelector('input[name=requesterIsSouthAfrican]:checked');
            postData += '&requesterIsSouthAfrican=' + requesterIsSouthAfricanChecked.value;
        }
        var requesterIdentificationNumber = this.form.querySelector('input[name=requesterIdentificationNumber]');
        if (requesterIdentificationNumber) {
            postData += '&requesterIdentificationNumber=' + requesterIdentificationNumber.value;
        }
        var requesterContactNumber = this.form.querySelector('input[name=requesterContactNumber]');
        if (requesterContactNumber) {
            postData += '&requesterContactNumber=' + requesterContactNumber.value;
        }
        var requesterEmailAddress = this.form.querySelector('input[name=requesterEmailAddress]');
        if (requesterEmailAddress) {
            postData += '&requesterEmailAddress=' + requesterEmailAddress.value;
        }
        var consentIndicator = this.form.querySelector('input[name=consentIndicator]');
        if (consentIndicator) {
            postData += '&consentIndicator=' + consentIndicator.value;
        }
        var requestedInformationDetails = this.form.querySelector('textarea[name=requestedInformationDetails]');
        if (requestedInformationDetails) {
            postData += '&requestedInformationDetails=' + requestedInformationDetails.value;
        }
        var legalRightsInformationDetails = form.querySelector('textarea[name=legalRightsInformationDetails]');
        if (legalRightsInformationDetails) {
            postData += '&legalRightsInformationDetails=' + legalRightsInformationDetails.value;
        }
        var responseFormat = form.querySelector('select[name=responseFormat]');
        if (responseFormat) {
            var options = '';
            for (var i = 0; i < responseFormat.options.length; i++) {
                if (responseFormat.options[i].selected) {
                    options += responseFormat.options[i].value + ',';
                }
            }
            options = options.substring(0, options.length - 1);
            postData += '&responseFormat=' + options;
        }
        var requestReason = form.querySelector('select[name=requestReason]');
        if (requestReason) {
            postData += '&requestReason=' + requestReason.value;
        }
        var destinationEmailAddress = form.querySelector('input[name=email]');
        if (destinationEmailAddress) {
            postData += '&email=' + destinationEmailAddress.value;
        }
        var emailSubject = form.querySelector('input[name=subject]');
        if (emailSubject) {
            postData += '&emailSubject=' + emailSubject.value;
        }
        // tslint:disable-next-line: triple-equals
        if (isThirdPartyChecked.value == 'Yes') {
            postData += '&ccEmailAddresses=' + destinationEmailAddress.value + ',' + requesterEmailAddress.value;
        }
        else {
            postData += '&ccEmailAddresses=' + destinationEmailAddress.value;
        }
        var bccAddresses = form.querySelector('input[name=recipient]');
        if (bccAddresses) {
            postData += '&bccAddresses=' + bccAddresses.value;
        }
        var serviceType = form.querySelector('input[name=service-type]');
        if (serviceType) {
            postData += '&service-type=' + serviceType.value;
        }
        // loader + hide form
        this.formLoader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + '/services/PromotionToPersonalInformationAct.jsp';
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            _this.formLoader.classList.remove('active');
            if (!response.data || (String(response.data).match(/(invalid)/gi))) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.formThankyou.classList.add('active');
                error.classList.add('active');
            }
            else if (response.data.success) {
                if (name) {
                    name.map(function (_item) {
                        _item.innerHTML = requesterFirstName.value;
                    });
                }
                if (referenceNumber && response.data.referenceNumber) {
                    referenceNumber.innerHTML = response.data.referenceNumber;
                }
                analyticsService.dtmFormComplete('complete', response.code);
                _this.formThankyou.classList.add('active');
                // tslint:disable-next-line: no-shadowed-variable
                var isThirdPartyChecked_1 = _this.form.querySelector('input[name=isThirdParty]:checked');
                // tslint:disable-next-line: triple-equals
                if (isThirdPartyChecked_1 && (isThirdPartyChecked_1.value == 'Yes')) {
                    success.classList.add('active');
                }
                else {
                    successThirdParty.classList.add('active');
                }
            }
            else {
                analyticsService.dtmFormComplete('complete', 'false');
                _this.formLoader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occurred|' + url);
            _this.formLoader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemPaiaRequest;
}(Base));
export { FormItemPaiaRequest };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-paia-request/form-item-paia-request.component.ts
// module id = 952
// module chunks = 0